import * as React from 'react';

import classify from 'src/utils/classify';

import CheckedBox from 'src/images/checked-box.svg';
import UncheckedBox from 'src/images/unchecked-box.svg';

import css from './checkbox.css';


type CheckboxProps = {
  checked: boolean;
  name?: string;
  onChange?: (evt: React.ChangeEvent<HTMLInputElement>) => unknown;
  className?: string;
  svgStyle?: {
    [cssProp: string]: unknown;
  };
  disabled?: unknown;
};

export default ({
  checked,
  name,
  onChange,
  className,
  svgStyle,
  disabled,
}: CheckboxProps): React.ReactElement<React.ComponentProps<'span'>> => (
  <span
    className={classify(
      css.fancyCheckbox,
      checked ? css.checked : css.unchecked,
      disabled ? css.disabled : null,
      className,
    )}
  >
    {checked ? (
      // @ts-expect-error - TS2322 - Type '{ [cssProp: string]: unknown; } | undefined' is not assignable to type 'CSSProperties | undefined'.
      <CheckedBox style={svgStyle} />
    ) : (
      // @ts-expect-error - TS2322 - Type '{ [cssProp: string]: unknown; } | undefined' is not assignable to type 'CSSProperties | undefined'.
      <UncheckedBox style={svgStyle} />
    )}
    <input
      type="checkbox"
      className={css.hiddenCheckbox}
      name={name}
      checked={checked}
      onChange={onChange}
      // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'boolean | undefined'.
      disabled={disabled}
    />
  </span>
);
